import { createContext } from 'react';

const TemporadasContext = createContext();

export default TemporadasContext;
